import { Link, useNavigate } from "react-router-dom";
import logo from "./../Images/vistaplots-logo.png";

import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";
import CustomToast from "../Components/CustomToast/CustomToast";
import { loginToggle } from "../Redux/Actions/dataAction";
import { signUp, verifySignUp } from "../Services/api";
// export default class Otp extends Component {
function Otp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { signUpData } = useSelector((store) => store.dataReducer);
  const [otp, setOtp] = useState();

  const resendOTP = async () => {
    try {
      const signUpResp = await signUp(signUpData.data);
      toast(<CustomToast type="success" message={signUpResp.msg} />, {
        autoClose: 3000,
      });
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  const doVerify = async () => {
    try {
      const request = {
        phoneCode: signUpData.data.phoneCode,
        phoneNumber: signUpData.data.phoneNumber,
        code: parseInt(otp),
      };

      const verifySignupResp = await verifySignUp(request);
      dispatch(loginToggle(verifySignupResp.data));
      navigate("/documents-upload");
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <div className="doc-area">
        <div className="container h-100">
          <div className="doc-box">
            <div className="doc-inner">
              <div className="">
                <div className="frgt-logo text-center mb-3">
                  <img src={logo} width={65} alt="" />
                </div>

                <div className="frgt-title text-center mb-4">
                  <h3>
                    Please Enter the One-time password to verify your mobile no.
                  </h3>
                  <p>
                    A otp has been send to ******
                    {signUpData.data.phoneNumber?.substring(
                      signUpData.data.phoneNumber?.length - 4
                    )}
                  </p>
                </div>
                <div className=" max-500 text-center mx-auto">
                  <div className="otp-form">
                    <form action="">
                      <div className="row">
                        <div className="mb-4 col-lg-12">
                          <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            separator={
                              <span className="seperator me-3"> </span>
                            }
                          />
                        </div>
                      </div>
                      <div className="text-center reset-button">
                        <button
                          className="text-center mb-3"
                          onClick={(event) => {
                            event.preventDefault();
                            doVerify();
                          }}
                        >
                          Validate
                        </button>
                        <p></p>
                      </div>
                    </form>
                    <div className="text-center reset-otp">
                      <p>
                        still can’t find the OTP?
                        <br />
                        <Link
                          to=""
                          onClick={() => {
                            resendOTP();
                          }}
                        >
                          Resend{" "}
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Otp;
